import Axios from "./Axios";
import { getBaseUrl } from "../constants";
import { setStartFormat, setEndFormat } from "../utils/dateformat/dateFormat";
import {
  TemplatesRequestProps,
  DetailRequestProps,
  PublishRequestProps,
  RejectRequestProps,
} from "./types";

const baseUrl = getBaseUrl();

const getTemplatesUrl = "/v1/templates";
const getTemplateDetailsUrl = "/v1/templates";
const publishTemplateUrl = "/v1/templates/publish";
const rejectTemplateUrl = "/v1/templates/reject";

/**
 * [GET] Templates API
 *
 * @param reviewStatus : 상태 필터값
 * @param page : 페이지
 * @param display : 페이지 당 갯수
 * @param startedAt : 조회 시작일
 * @param endedAt : 조회 종료일
 * @param searchType : 검색 대상 필터
 * @param searchText : 검색어
 *
 * @returns Promise
 */
export const getTemplates = ({
  reviewStatus,
  page,
  display,
  startedAt,
  endedAt,
  searchType,
  searchText,
  sort,
  language,
  category,
  mixability,
  reference,
  asset,
  entertainment,
  application,
  ratio,
  isBlind,
  sortKey,
}: TemplatesRequestProps) => {
  const data = {
    reviewStatus,
    page,
    display,
    startedAt:
      typeof startedAt === "string" ? startedAt : setStartFormat(startedAt),
    endedAt:
      typeof endedAt === "string" ? endedAt : setEndFormat(endedAt),
    searchType,
    searchText,
    sort,
    language,
    category,
    mixability,
    reference,
    asset,
    entertainment,
    application,
    ratio,
    isBlind,
    sortKey,
  };
  const method = "GET";
  const url = `${baseUrl}${getTemplatesUrl}`;

  return Axios(method, url, data);
};

/**
 * [GET] Template Details API
 * @param data : Templates Id 값
 * @returns Promise
 */
export const getTempalteDetails = ({ data }: DetailRequestProps) => {
  const method = "GET";
  const url = `${baseUrl}${getTemplateDetailsUrl}/${data}`;

  return Axios(method, url);
};

/**
 * [GET] Publish Template API
 * @param templatesIds : Templates Id 값
 * @returns Promise
 */
export const publishTemplate = ({ templatesIds }: PublishRequestProps) => {
  const method = "PATCH";
  const url = `${baseUrl}${publishTemplateUrl}`;
  const data = { templatesIds };

  return Axios(method, url, data);
};

/**
 * [GET] Reject Template Details API
 * @param templatesIds : Templates Id 값
 * @param rejected : {
 *  reason: string;
 *  falis: string[];
 * }
 * @returns Promise
 */
export const rejectTemplate = ({
  templatesIds,
  rejected,
}: RejectRequestProps) => {
  const method = "PATCH";
  const url = `${baseUrl}${rejectTemplateUrl}`;
  const data = {
    templatesIds,
    rejected,
  };

  return Axios(method, url, data);
};
